import React, {Component} from 'react';
import classNames from "classnames";
import {Link, withRouter} from 'react-router-dom';
import Select from 'react-select';
import CounterView from '../Counter/CounterView';
import {translate} from 'react-i18next';
import {calcCostPizza, getCrustOfPizza, getFormatPrice, getSauceOfPizza, getSizeOfPizza} from "../../helpers";
import PropTypes from "prop-types";

class ProductCustomizeView extends Component {
  constructor(props) {
    super(props);

    this.getSizeOfPizza = this.getSizeOfPizza.bind(this);
    this.getOptionsCrust = this.getOptionsCrust.bind(this);
    this.isCheckedIngredient = this.isCheckedIngredient.bind(this);
    this.toggleIngredient = this.toggleIngredient.bind(this);
    this.setAmountIngredient = this.setAmountIngredient.bind(this);
    this.getPrice = this.getPrice.bind(this);
    this.backPage = this.backPage.bind(this);
    this.getAmountIngredients = this.getAmountIngredients.bind(this);
  }

  getSizeOfPizza(product) {
    const {crustID, t} = this.props;
    return getSizeOfPizza(product, crustID, undefined, undefined, t);
  }

  isCheckedIngredient(ingredient) {
    const amount = this.getAmountIngredients(ingredient);
    return amount > 0;
  };

  getAmountIngredients(ingredient) {
    const {defaultIngredients, extraIngredientsMinus, extraIngredientsPlus} = this.props;
    const extraIngredientPlus = extraIngredientsPlus.find(extra => extra.ingredient.id === ingredient.id);
    const extraIngredientMinus = extraIngredientsMinus.find(extra => extra.ingredient.id === ingredient.id);
    const defaultIngredient = defaultIngredients.find(extra => extra.ingredient.id === ingredient.id);
    const defaultAmount = !!defaultIngredient ? parseInt(defaultIngredient.amount, 10) : 0;
    const plusAmount = !!extraIngredientPlus ? parseInt(extraIngredientPlus.amount, 10) : 0;
    const minusAmount = !!extraIngredientMinus ? parseInt(extraIngredientMinus.amount, 10) : 0;
    return defaultAmount - minusAmount + plusAmount;
  }

  getOptionsCrust(product) {
    const {size} = this.props;
    return getCrustOfPizza(product, size, this.props.language);
  }

  getPrice() {
    const {product, crustID, size, quantity, ingredients,
      extraIngredientsMinus, extraIngredientsPlus} = this.props;
    return getFormatPrice(calcCostPizza(product, crustID, size, quantity, ingredients,
      extraIngredientsMinus, extraIngredientsPlus));
  }

  toggleIngredient(event, ingredient) {
    const {target} = event;
    this.props.toggleIngredient(target.checked, ingredient);
  }

  setAmountIngredient(ingredient, amount) {
    this.props.setAmountIngredient(ingredient, amount);
  }

  backPage(e) {
    e.preventDefault();
    const {language, restaurant} = this.props;
    if (this.props.history.length > 3) {
      this.props.history.goBack();
    } else {
      this.props.history.push(`/${language}/${restaurant.name_for_url}/products/pizza`);
    }
  }

  render() {
    const {product, size, crustID, sauceID, quantity, t, sauces, ingredients, language, increase,
      decrease, selectedCountIngredients, onChangeOptions} = this.props;
    return (
      <div className="customization">
        <div className="app__wrapper">
          <div className="customization__inner">
            <Link className="return-button" to='#' onClick={this.backPage}>{t('back')}</Link>
            <div className="customization__top">
              <div className="customization__title">
                <div className="customization__heading">{product[`name_${language}`]}</div>
                {product[`description_${language}`]}
              </div>
              <div className="customization__options">
                <span className="select-panel select-panel--counter">
                  <CounterView
                    increase={increase}
                    decrease={decrease}
                    value={quantity}
                  />
                </span>
                <span className="select-panel">
                  <label>{t('sizePizza')}</label>
                  <Select
                    name="form-size-product"
                    clearable={false}
                    value={size}
                    onChange={e => onChangeOptions(e, 'size')}
                    options={this.getSizeOfPizza(product)}
                    searchable={false}
                  />
                </span>
                <span className="select-panel">
                  <label>{t('crustPizza')}</label>
                  <Select
                    name="form-crust-product"
                    clearable={false}
                    value={crustID}
                    onChange={e => this.props.onChangeOptions(e, 'crustID')}
                    options={this.getOptionsCrust(product)}
                    searchable={false}
                  />
                </span>
                <button
                  className="customization__btn customization__btn--2-lines"
                  onClick={() => this.props.updateToCard()}
                >
                  {t('updateBasket')}
                  <div>&nbsp;{this.getPrice().replace('.', ',')}€ TTC</div>
                </button>
              </div>
            </div>
            {product.sauce_change && <div className='customization__add-on'>
              <span className="select-panel select-panel--rounded">
                <label>{t('sauce')}</label>
                <Select
                  name="form-sauce-product"
                  clearable={false}
                  value={sauceID}
                  onChange={e => this.props.onChangeOptions(e, 'sauceID')}
                  options={getSauceOfPizza(sauces, language)}
                  searchable={false}
                />
              </span>
            </div>}
              <div
                className={
                  classNames('customization__alert', { 'customization__alert--visible': selectedCountIngredients > 7})
                }
              >
                {t('ingredients_warning')}
              </div>

            <div className="customization__list">
              <div className="customization__list-title">
                {t('toppings')}
              </div>
              <div className="customization__list-items">
                {ingredients.map((ingredient) => (
                  <div className="customization__list-item" key={ingredient.id}>
                    <label className="checkbox">
                      <input
                        type="checkbox"
                        className="checkbox__input"
                        checked={this.isCheckedIngredient(ingredient)}
                        onChange={(e) => this.toggleIngredient(e, ingredient)}
                      />
                      <span className="checkbox__text">
                        {ingredient[`name_${language}`]}
                        <div className="customization__list-price">{getFormatPrice(parseFloat(ingredient[size]))}€</div>
                      </span>
                    </label>
                    <span className="customization__list-buttons-wrap">
                      {this.isCheckedIngredient(ingredient) &&
                      <span className="customization__list-buttons">
                        <button className={
                          classNames('customization__list-btn', {
                            'customization__list-btn--active': 1 === this.getAmountIngredients(ingredient)
                          })}
                                onClick={() => this.setAmountIngredient(ingredient, '1')}
                        >1x</button>
                        <button className={
                          classNames('customization__list-btn', {
                            'customization__list-btn--active': 2 === this.getAmountIngredients(ingredient)
                          })}
                                onClick={() => this.setAmountIngredient(ingredient, '2')}
                        >2x</button>
                      </span>
                      }
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="customization__rotating-pizza">
          <img src={product.photo_customize_thumbnail || product.photo} alt={product.name}/>
        </div>
      </div>
    );
  }
}

ProductCustomizeView.propTypes = {
  product: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  sauces: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  size: PropTypes.string,
  crustID: PropTypes.number,
  sauceID: PropTypes.number,
  quantity: PropTypes.number,
  defaultIngredients: PropTypes.array,
  ingredients: PropTypes.array,
  language: PropTypes.string,
  onChangeOptions: PropTypes.func,
  increase: PropTypes.func,
  decrease: PropTypes.func,
  updateToCard: PropTypes.func,
  toggleIngredient: PropTypes.func,
  setAmountIngredient: PropTypes.func,
  selectedCountIngredients: PropTypes.number,
};

export default withRouter(translate('translations')(ProductCustomizeView));


// WEBPACK FOOTER //
// ./src/components/Product/ProductCustomizeView.js